import apiClient from './api';

/**
 * Event API Service for Kuseri (Admin Portal)
 */

// Event Categories
export const getEventCategories = () => apiClient.get('/events/categories');
export const getCategories = () => getEventCategories();

// Events
export const getAllEvents = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
      params.append(key, filters[key]);
    }
  });
  return apiClient.get(`/events?${params.toString()}`);
};

export const getAdminEvents = (filters = {}) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach(key => {
    if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
      params.append(key, filters[key]);
    }
  });
  return apiClient.get(`/events/admin/all?${params.toString()}`);
};

export const getEvents = (filters = {}) => getAllEvents(filters);

export const getEventById = (id) => apiClient.get(`/events/by-id/${id}`);

export const getEventBySlug = (slug) => apiClient.get(`/events/${slug}`);

export const createEvent = (eventData) => apiClient.post('/events', eventData);

export const updateEvent = (id, eventData) => apiClient.put(`/events/${id}`, eventData);

export const deleteEvent = (id) => apiClient.delete(`/events/${id}`);

// Admin Functions
export const getPendingApprovals = () => apiClient.get('/events/admin/pending-approval');

export const approveEvent = (id) => apiClient.post(`/events/${id}/approve`);

export const rejectEvent = (id, rejectionReason) => 
  apiClient.post(`/events/${id}/reject`, { rejectionReason });

export const getMyEvents = () => apiClient.get('/events/my/events');

// Provider search (for permission assignment)
export const searchProviders = (q = '') => apiClient.get(`/events/providers/search?q=${encodeURIComponent(q)}`);

// Event Permissions (cross-provider ticket selling)
export const getEventPermissions = (eventId) => apiClient.get(`/events/${eventId}/permissions`);
export const grantEventPermission = (eventId, providerId) => apiClient.post(`/events/${eventId}/permissions`, { providerId });
export const revokeEventPermission = (eventId, providerId) => apiClient.delete(`/events/${eventId}/permissions/${providerId}`);

// Event Sales Audit
export const getEventSalesAudit = (eventId) => apiClient.get(`/events/${eventId}/sales-audit`);

// Event Bookings and Tickets
export const getEventBookings = (eventId) => apiClient.get(`/events/${eventId}/bookings`);
export const getEventTickets = (eventId) => apiClient.get(`/events/${eventId}/tickets`);
export const getEvent = (id) => getEventById(id);

// All Bookings (Admin)
export const getAllBookings = () => apiClient.get('/events/bookings/all', { headers: { 'Cache-Control': 'no-cache' }, params: { _t: Date.now() } });
export const getBookingDetails = (bookingId) => apiClient.get(`/events/bookings/${bookingId}`);
export const getBookingTickets = (bookingId) => apiClient.get(`/events/bookings/${bookingId}/tickets`);
export const resendTicket = (ticketId) => apiClient.post(`/events/bookings/${ticketId}/resend`);

// Admin-assisted booking (sell tickets on behalf of a customer)
export const createBooking = (eventId, bookingData) => apiClient.post(`/events/${eventId}/book`, bookingData);

export default {
  getEventCategories,
  getCategories,
  getAllEvents,
  getAdminEvents,
  getEvents,
  getEventById,
  getEventBySlug,
  getEvent,
  getEventBookings,
  getEventTickets,
  getAllBookings,
  getBookingDetails,
  getBookingTickets,
  resendTicket,
  createBooking,
  createEvent,
  updateEvent,
  deleteEvent,
  getPendingApprovals,
  approveEvent,
  rejectEvent,
  getMyEvents,
  searchProviders,
  getEventPermissions,
  grantEventPermission,
  revokeEventPermission,
  getEventSalesAudit
};
